import { render } from "./OrderPurchases.vue?vue&type=template&id=b4415608&scoped=true"
import script from "./OrderPurchases.vue?vue&type=script&lang=js"
export * from "./OrderPurchases.vue?vue&type=script&lang=js"

import "./OrderPurchases.vue?vue&type=style&index=0&id=b4415608&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4415608"]])

export default __exports__